import { useLanguage } from "@/contexts/LanguageContext";

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div role="group" aria-label="Language" className="flex items-center bg-ink-700 border border-white/10 rounded-full p-0.5 text-[11px] font-medium">
      <button type="button" onClick={() => setLanguage("en")} aria-pressed={language === "en"} aria-label="Switch to English"
        className={`px-2.5 py-1 rounded-full transition-colors ${language === "en" ? "bg-violet text-white" : "text-white/50 hover:text-white"}`}>
        EN
      </button>
      <button type="button" onClick={() => setLanguage("de")} aria-pressed={language === "de"} aria-label="Auf Deutsch wechseln"
        className={`px-2.5 py-1 rounded-full transition-colors ${language === "de" ? "bg-violet text-white" : "text-white/50 hover:text-white"}`}>
        DE
      </button>
    </div>
  );
};

export default LanguageSwitcher;
